
import React from "react";
import { TableHeader as UITableHeader, TableRow, TableHead } from "@/components/ui/table";
import { isIronTest } from "@/components/level3/scoring/utils";
import { useTranslation } from "react-i18next";

interface TableHeaderProps {
  isChippingTest?: boolean;
  isSpecialPutts?: boolean;
  isWedgingTest?: boolean;
  isPuttingTest?: boolean;
  isIronTest?: boolean;
  getTableHeadTitle: () => string;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  isChippingTest = false,
  isSpecialPutts = false,
  isWedgingTest = false,
  isPuttingTest = false,
  isIronTest = false,
  getTableHeadTitle
}) => {
  const { t } = useTranslation('training');
  const title = getTableHeadTitle();

  return (
    <UITableHeader>
      <TableRow>
        <TableHead className="w-[100px]">{t('interface.tableHeaders.point')}</TableHead>
        <TableHead className="w-[120px]">{t('interface.tableHeaders.distance')}</TableHead>
        {Array.from({ length: 10 }, (_, index) => (
          <TableHead key={index} className="text-center w-[50px]">
            {index + 1}
          </TableHead>
        ))}
        <TableHead className="text-center w-[80px]">{t('interface.tableHeaders.total')}</TableHead>
      </TableRow>
    </UITableHeader>
  );
};

export default TableHeader;
